import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { EOtpremnica, EOtpremnicaDto, EOtpremniceClient } from "@kodit/core/data-api";
import { BaseService } from "@kodit/core/services";
import { Observable } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class EotpremnicaResolver
  extends BaseService
  implements Resolve<EOtpremnicaDto> {
  constructor(private _client: EOtpremniceClient) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<EOtpremnicaDto>
    | Promise<EOtpremnicaDto>
    | EOtpremnicaDto
    | null {
    const id = Number.parseInt(route.paramMap.get('id') ?? '');
    return this._client.getEOtpremnica(id).pipe(
      map((x) => x.data),
      catchError(this.handleError),
      finalize(() => {
        //this._configService.setIsBusy = false;
      })
    );
  }
}
